<template>
  <v-navigation-drawer v-bind="$attrs" :mini-variant.sync="mini">
    <template v-slot:prepend>
      <v-toolbar flat dense v-if="!mini">
        <v-toolbar-title class="subtitle-1">Media manager</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon small @click="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>

      <v-btn class="mt-2" icon small @click="mini = !mini" v-else>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-divider v-show="!mini"></v-divider>
    </template>

    <media-manager-card v-show="!mini"></media-manager-card>

    <template v-slot:append v-show="!mini">
      <v-divider></v-divider>

      <v-toolbar flat dense>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="closeEditor()">Close</v-btn>
      </v-toolbar>
    </template>
  </v-navigation-drawer>
</template>

<script>
import MediaManagerCard from './MediaManagerCard'
import { mapActions } from 'vuex'

export default {
  name: 'MediaManager',
  components: {
    MediaManagerCard
  },
  data: () => ({
    mini: false
  }),
  methods: {
    ...mapActions('editor', ['closeEditor'])
  }
}
</script>